import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { MapInfoWindow } from '@angular/google-maps';
import { ActivatedRoute } from '@angular/router';

import { has, isNil } from 'lodash-es';

import { AddressEnum } from '../../../../../../enums/address';
import { WalkingFarmProperty } from '../../../../../../typings/walking-farm';
import { AddressPipe } from '../../../../../pipes/address.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-walking-farm-view-map-info-window',
  standalone: false,
  templateUrl: './map-info-window.component.html'
})
export class MapInfoWindowComponent implements OnChanges {
  private activatedRoute = inject(ActivatedRoute);
  private addressPipe = inject(AddressPipe);
  private document = inject<Document>(DOCUMENT);

  @ViewChild(MapInfoWindow) infoWindow?: MapInfoWindow;

  @Input() walkingFarmId: string | null = null;
  @Input() property: WalkingFarmProperty | null = null;

  @Output() closeWindow = new EventEmitter<void>();

  options: google.maps.InfoWindowOptions = {};

  defaultBackHref: string | undefined;

  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'] ?? '/';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'property') && !isNil(this.property)) {
      const header = this.document.createElement('div');
      header.innerText = this.addressPipe.transform(this.property, AddressEnum.LineOne);
      header.classList.add('tw:text-sm');
      header.classList.add('tw:font-bold');
      const subHeader = this.document.createElement('div');
      subHeader.classList.add('tw:text-xs');
      subHeader.classList.add('tw:font-normal');
      subHeader.innerText = this.addressPipe.transform(this.property, AddressEnum.LineTwo);
      header.appendChild(subHeader);
      this.options = {
        headerContent: header,
        pixelOffset: new google.maps.Size(0, -36, 'px', 'px'),
        position: {
          lat: parseFloat(`${this.property.A041_Latitude}`),
          lng: parseFloat(`${this.property.A042_Longitude}`)
        }
      };
    }
  }

  open() {
    this.infoWindow?.open();
  }

  closeClick() {
    this.closeWindow.emit();
  }
}
